import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const charityOrganizationPageSlice = createSlice({
    name: "charityOrganizationPageSlice",
    initialState,
    reducers: {
        setCharityOrganizationPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setCharityOrganizationCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setCharityOrganizationTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setCharityOrganizationTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetCharityOrganizationPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setCharityOrganizationPageLimit,
    setCharityOrganizationCurrentPage,
    setCharityOrganizationTotalCount,
    setCharityOrganizationTotalPages,
    resetCharityOrganizationPagination,
} = charityOrganizationPageSlice.actions;

export default charityOrganizationPageSlice.reducer;
